module.exports = __webpack_public_path__ + "static/img/meskie.aecec48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meskie.png
// module id = 301
// module chunks = 2